import type { UiConfigOverlay } from "@repo/ui-config";

function isUnknownRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function readUiConfigOverlayNumberFormatMode(
  overlay: UiConfigOverlay,
): string | undefined {
  const numberFormat = overlay.lenses?.numberFormat;
  if (!isUnknownRecord(numberFormat)) {
    return undefined;
  }

  return typeof numberFormat.mode === "string"
    ? numberFormat.mode
    : undefined;
}

export function preserveUiConfigNumberFormatOverlayFields(
  numberFormat: unknown,
): Readonly<Record<string, unknown>> {
  return isUnknownRecord(numberFormat) ? numberFormat : {};
}
